var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    className: "logo",
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37_204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2559 25.524C16.484 24.1881 15.8309 22.815 15.2371 21.4271C12.6246 25.8877 10.9473 30.8306 10.2941 35.9369C15.2891 38.5049 21.3156 38.8017 26.7113 36.4045C23.0004 33.4877 19.757 29.8584 17.2559 25.524ZM19.2004 23.483C21.7609 27.9732 25.1973 31.8994 29.2941 35.0166C34.0145 31.9736 37.2875 26.897 37.9035 21.0338C33.5246 22.7853 28.7598 23.7799 23.7574 23.7799C22.2137 23.7799 20.6996 23.6611 19.2004 23.483ZM15.0367 16.9592C9.86367 16.9295 4.74258 17.9463 0 19.9353C0.274609 25.5463 3.02812 30.9123 7.80781 34.3857C8.47578 29.7174 9.99727 25.0935 12.5059 20.7592C13.2703 19.4232 14.1313 18.1689 15.0367 16.9592ZM18.7996 14.5545C16.2391 10.0642 12.8027 6.13064 8.70586 3.02087C3.98555 6.06384 0.7125 11.1404 0.0964844 17.0037C4.47539 15.2521 9.24023 14.2576 14.2426 14.2576C15.7863 14.2576 17.3004 14.3763 18.7996 14.5545ZM20.7441 12.5209C21.516 13.8568 22.1691 15.2299 22.7629 16.6177C25.3754 12.1572 27.0527 7.21423 27.7059 2.10798C22.7109 -0.459986 16.6844 -0.756861 11.2887 1.6404C14.9996 4.54978 18.243 8.1865 20.7441 12.5209ZM22.9633 21.0783C28.1363 21.108 33.2574 20.0912 38 18.1021C37.7254 12.4912 34.9719 7.12517 30.1996 3.65173C29.5316 8.32009 28.0027 12.9439 25.5016 17.2783C24.7297 18.6142 23.8687 19.8685 22.9633 21.0783Z",
    fill: "#0080FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37_204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.13418ce997c9c50b4f7cb3a2a51eec7b.svg";
export { ForwardRef as ReactComponent };